import {
    Stack,
    Box,
    Typography
} from "@mui/material";
import React from "react";

/*
 * This should be the landing page for Auth with all of the 
 * customized buttons where users choose to render the 
 * Google, Facebook, or Twitter provider with the app children
* */
export default function Auth(props) {
    const {
        LoginHeaderLogo,
        LoginFooterLogo,
        signInBlurb,
        signInBackgroundColor
    } = props;

    return (
        <React.Fragment>
            <Box 
                backgroundColor={signInBackgroundColor || '#23102E'}
                sx={{width: '100%', height: '100%'}} 
                display="flex"
                justifyContent="start"
                alignItems="center"
                flexDirection="column"
                paddingX='20px'
            >
                <Box display={'flex'} alignItems={'center'} justifyContent={'center'} sx={{margin: '20px', maxWidth: '400px', width: '100%'}}>
                    <img style={{maxWidth: '100%', height:'100%'}} src={LoginHeaderLogo} alt="login header" />
                </Box>
                <Box padding='20px' sx={{backgroundColor: 'white', width: '100%', maxWidth: '335px', borderRadius: '20px'}}>
                    <Stack direction="column" alignItems="center" justifyContent="center" gap='4px'>
                        <Typography sx={{fontSize: '24px', fontWeight: 800, lineHeight:'28.8px'}}>Check your email</Typography>
                        {signInBlurb && (
                            <Typography sx={{color: '#5B626E',fontSize:'14px',lineHeight:'21px', fontWeight:700,width:'60%',textAlign:'center'}}>{signInBlurb}</Typography>
                        )}
                    </Stack>
                    <Stack gap="16px" sx={{marginTop: '20px'}} direction='column' justifyContent='center'>
                        <Typography sx={{color: '#5B626E',fontSize:'14px',lineHeight:'21px', fontWeight:700,textAlign:'center'}}>Please check your email and click the verification link to sign in</Typography>
                    </Stack>
                </Box>
                {LoginFooterLogo && (
                    <Box display={'flex'} alignItems={'center'} justifyContent={'center'} sx={{margin: '20px', maxWidth: '400px', width: '100%'}}>
                        <Box>
                            <img style={{maxWidth: '100%', height:'100%'}} src={LoginFooterLogo} alt="main circle" />
                        </Box>
                    </Box>
                )}
            </Box>
        </React.Fragment>
    );
} 
